import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { register as registerSwiperElements } from 'swiper/element/bundle';



if (environment.production) {
  enableProdMode();
}

document.addEventListener('DOMContentLoaded', () => {
  registerSwiperElements()
  platformBrowserDynamic()
    .bootstrapModule(AppModule)
    .catch((err) => console.error(err));

  if (window.location.pathname.includes("registro")) {
    document.getElementsByTagName("body")[0].classList.add("landing-page")
  }

});


